import { AccountFeature, Account } from '../common/types/Accounts';
import { useActiveAccount } from '.';
import { useCallback } from 'react';
import { Features } from './useFeatures';
import { useSelector } from 'react-redux';
import { featuresSelectors } from '../redux/modules/features';

export const v2AccountFeatures = [
  'genomics',
  'ontologies',
  'automation',
  'circles',
  'cohorts',
  'programs',
  'trialMatching',
  'marketplace',
  'customApps',
  'notebooks',
  'insights',
  'files',
];

export type GetIsAccountFeatureDisabled = (
  accountFeature: AccountFeature,
) => boolean;

const emptyFeatures: AccountFeature[] = [];

export function useEnabledAccountFeatures(): AccountFeature[] {
  const activeAccount = useActiveAccount();
  const features = useSelector(featuresSelectors.selectFeatures);
  const accountToggleV2Active = (features || {})['accountToggleV2'] === true;

  return [
    ...new Set([
      ...(activeAccount?.features || []),
      ...(accountToggleV2Active ? [] : v2AccountFeatures),
    ]),
  ] as AccountFeature[];
}

export function getIsAccountFeatureDisabled(
  account: Account,
  features: Features,
  accountFeature: AccountFeature,
) {
  const accountFeatures = account?.features || emptyFeatures;

  const accountToggleV2Active = (features || {})['accountToggleV2'] === true;

  if (accountFeatures.includes(accountFeature)) return false;

  const v2FeatureEnabled =
    v2AccountFeatures.includes(accountFeature) && !accountToggleV2Active;

  return !v2FeatureEnabled;
}

export function useGetIsAccountFeatureDisabled(): GetIsAccountFeatureDisabled {
  const activeAccount = useActiveAccount();
  const features = useSelector(featuresSelectors.selectFeatures);

  return useCallback(
    (accountFeature: AccountFeature): boolean =>
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      getIsAccountFeatureDisabled(activeAccount, features, accountFeature),
    [activeAccount, features],
  );
}

function useIsAccountFeatureDisabled(accountFeature: AccountFeature): boolean {
  return useGetIsAccountFeatureDisabled()(accountFeature);
}

export default useIsAccountFeatureDisabled;
